import axios from "axios";
import { useAuth } from "./auth";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: `${BASE}/api`, timeout: 30000 });

api.interceptors.request.use((cfg) => {
  const t = sessionStorage.getItem("balaji_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && typeof window !== "undefined" && window.location.pathname.startsWith("/admin")) {
      // useAuth.getState() — Zustand exposes this outside React components —
      // keeps the in-memory store and storage in sync instead of just
      // clearing sessionStorage directly.
      useAuth.getState().logout();
      if (!window.location.pathname.endsWith("/admin/login")) window.location.href = "/admin/login";
    }
    return Promise.reject(err);
  }
);

// Convert relative upload URLs from backend to absolute
export const absUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("/api/")) return `${BASE}${url}`;
  return url;
};